import React from 'react'
import { formatString } from '@cbgms/base/utils/helpers'
import { useTranslation } from 'react-i18next'
import navigation from 'utils-support/navigation'
import { Box, Card, CardContent, IconButton, List, ListItem, ListItemIcon, ListItemText, Tooltip, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import LocalPhoneIcon from '@mui/icons-material/LocalPhone'
import LabelIcon from '@mui/icons-material/Label'
import { ShopStatus } from '@cbgms/api'

const ShopCard: React.FC<any> = props => {
  const {
    CompanyUUID,
    EmailAddress,
    ID,
    Name,
    PhoneNumber,
    VisitorAddress,
    VisitorCity,
    VisitorHouseNumber,
    VisitorHouseNumberAddition,
    VisitorPostalCode,
    Status
  } = props
  const { t } = useTranslation()

  return (
    <Card variant='outlined' sx={{ backgroundColor: Status === ShopStatus.Archive ? 'grey.200' : 'white' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant='h6' noWrap>
            {Name}
          </Typography>
          <Tooltip title={`${t('global.edit')}`} placement='top' arrow>
            <IconButton
              onClick={() => navigation.push(`/companies/${CompanyUUID}/shops/edit/${ID}`)}
              data-testid='shopcard-edit-icon'
              sx={{ marginLeft: 'auto' }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
        </Box>
        <List dense>
          <ListItem disableGutters>
            <ListItemIcon>
              <LocationOnIcon />
            </ListItemIcon>
            {formatString(VisitorAddress, VisitorHouseNumber, VisitorHouseNumberAddition)}
          </ListItem>
          <ListItem disableGutters>
            <ListItemText inset>{formatString(VisitorPostalCode, VisitorCity)}</ListItemText>
          </ListItem>
          <ListItem disableGutters>
            <ListItemIcon>
              <AlternateEmailIcon />
            </ListItemIcon>
            {EmailAddress}
          </ListItem>
          <ListItem disableGutters>
            <ListItemIcon>
              <LocalPhoneIcon />
            </ListItemIcon>
            {PhoneNumber}
          </ListItem>
          <ListItem disableGutters>
            <ListItemIcon>
              <LabelIcon />
            </ListItemIcon>
            {ID}
          </ListItem>
        </List>
      </CardContent>
    </Card>
  )
}

export default ShopCard
